import { render, staticRenderFns } from "./drop100-text.vue?vue&type=template&id=312585a8&scoped=true&"
import script from "./drop100-text.vue?vue&type=script&lang=js&"
export * from "./drop100-text.vue?vue&type=script&lang=js&"
import style0 from "./drop100-text.vue?vue&type=style&index=0&id=312585a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312585a8",
  null
  
)

export default component.exports